module.exports = __webpack_public_path__ + "static/media/dsb-WINE-CHAMPAGNE.32fd7e2b.jpg";